import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiChip from '@material-ui/core/Chip/Chip';
import clsx from 'clsx';
import { error } from '@hilma/netina2all';

interface ChipProps {
	chipColor?: string;
	chipClassName?: string;
	label?: string;
};

const Chip: React.FC<ChipProps> = ({ chipColor, chipClassName, label }) => {

	const classes = useStyles({ chipColor });

	return <MuiChip className={clsx(classes.chip, chipClassName)} classes={{ label: classes.chipLabel }} label={label} />

};

export default Chip;

const useStyles = makeStyles(({
	chip: {
		color: ({ chipColor }: { chipColor?: string | false | null }) => chipColor || error + '!important',
		backgroundColor: ({ chipColor }: { chipColor?: string | false | null }) => (chipColor || error) + '14',
		width: 'max-content',
		height: 'max-content',
	},
	chipLabel: {
		fontFamily: 'Assistant-Bold !important',
		lineHeight: 1.75
	}
}));